import InfoMessage from './InfoMessage';
export type { InfoMessageProps } from './InfoMessage.types';

export default InfoMessage;
